export default class ProductDetailVideo {
  constructor({ el }) {
    this.DOM = document.querySelector(el)
    this.el = el

    // 当前播放视频的索引
    this.curIndex = 0

    if (this.DOM) {
      this.jkyVideos = this.DOM.querySelectorAll('jky-video')

      // 是否都配置的 mp4 格式的视频
      const mp4Video = Array.from(this.jkyVideos).filter(item => item.getAttribute('video-type') === 'mp4')
      this.isAllMp4 = mp4Video.length === this.jkyVideos.length

      // 修正 this 指向，方便新增和移除事件
      this.videoEndedPlayEvent = this.videoEndedPlayEvent.bind(this)

      this.init()
      this.observe()
    }
  }
  init() {
    this.jkyVideos.forEach((item, index) => {
      const posterWrap = item.querySelector('.jky-video-poster_container')
      posterWrap.onclick = () => {
        this.curIndex = index

        // 暂停全部
        this.jkyVideos.forEach(it => {
          if (it && it.pause) {
            it.videoInfo.autoplay = false
            it.pause()
          }
        })

        // 播放当前
        this.playVideo(item)
      }
    })
  }
  playVideo(curVideo) {
    if (curVideo && curVideo.loadContent) {
      curVideo.videoInfo.autoplay = true
      curVideo.loadContent(false)

      if (this.isAllMp4) {
        // 监听视频播放完成事件
        curVideo.querySelector('video').addEventListener('ended', this.videoEndedPlayEvent)
      }
    }
  }
  // 视频播放完成事件
  videoEndedPlayEvent() {
    this.curIndex++
    this.playVideo(this.jkyVideos[this.curIndex])
  }
  observe() {
    // 视频进入视口监听播放
    const Observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (this.curIndex !== this.jkyVideos.length - 1) {
            // 播放视频
            const curVideo = this.jkyVideos[this.curIndex]
            this.playVideo(curVideo)
          }
        } else {
          // 暂停播放
          const curVideo = this.jkyVideos[this.curIndex]
          if (curVideo && curVideo.pause) {
            curVideo.videoInfo.autoplay = false
            curVideo.pause()

            if (this.isAllMp4) {
              // 移除当前视频播放完成事件
              curVideo.querySelector('video')?.removeEventListener('ended', this.videoEndedPlayEvent)
            }

          }
        }
      })
    },{
      root: null,
      rootMargin: '0px',
      threshold: 0.25, // 设置阈值为80%，即视频可见面积超过50%触发播放
    })

    Observer.observe(this.DOM)
  }
}
